module.exports = __webpack_public_path__ + "61c3ee7cd84290523ed9cfcc85287507.fbx";